import { ThemeParams } from 'telegram-web-app';

import { getWebApp } from '@tg-web/utils';

import { DefaultThemeType } from '../model/defaultTheme';

export const setAppBackground =
  (defaultTheme: DefaultThemeType, themeColors: Required<ThemeParams>) =>
  (themeOverride: Partial<DefaultThemeType>) => {
    const theme: DefaultThemeType = { ...defaultTheme, ...themeOverride };

    // set style of body to fix bg bug in web and desktop telegram
    if (theme.backgroundColor === 'bg_color') {
      document.body.style.backgroundColor = themeColors.bg_color;
    } else if (theme.backgroundColor === 'secondary_bg_color') {
      document.body.style.backgroundColor = themeColors.secondary_bg_color;
    } else {
      document.body.style.backgroundColor = theme.backgroundColor;
    }

    getWebApp().setBackgroundColor(theme.backgroundColor);
    getWebApp().setHeaderColor(theme.headerColor);
    getWebApp().setBottomBarColor(theme.bottomBarColor);
  };
